module.exports = __webpack_public_path__ + "privateAssetLabCarouselVdpar.17d5e1f69261e8f48b0e60588ba8272e.png";